import classnames from 'classnames';
import React, { useId } from 'react';

import '@eika/radio-button-style';

import ErrorMessageLabel from './ErrorMessageLabel';
import RadioButtonCard from './RadioButtonCard';
import { RadioButtonLabel } from './RadioButtonLabel';
import { RadioButtonCardsProps } from './Types';

const RadioButtonCards = ({
    label,
    onChange,
    options,
    selectedOption,
    sublabel,
    className,
    name,
    errorMessage,
    dataTrackId = label,
    required = false,
    expandCheckmarksOnSelect,
}: RadioButtonCardsProps): JSX.Element => {
    const errorId = useId();

    return (
        <fieldset className={classnames('sgw-radio-button-panels', className)}>
            {label && <RadioButtonLabel label={label} sublabel={sublabel} />}
            {options.map(
                ({
                    value,
                    label: optionLabel,
                    checkmarks,
                    description,
                    id,
                    highlightedNote,
                    bannerElement,
                    ref,
                    children,
                    expandableCheckmarks,
                    expandableLabel,
                    dataTrackLinkname,
                    ...rest
                }) => (
                    <RadioButtonCard
                        onChange={onChange}
                        selectedOption={selectedOption}
                        name={name}
                        describedBy={errorId}
                        required={required}
                        error={!!errorMessage}
                        expandCheckmarksOnSelect={expandCheckmarksOnSelect}
                        label={optionLabel}
                        value={value}
                        description={description}
                        id={id}
                        dataTrackId={dataTrackId}
                        dataTrackLinkname={dataTrackLinkname}
                        highlightedNote={highlightedNote}
                        checkmarks={checkmarks}
                        expandableLabel={expandableLabel}
                        expandableCheckmarks={expandableCheckmarks}
                        bannerElement={bannerElement}
                        inputRef={ref ?? rest.inputRef}
                        key={rest.key ?? value}
                        {...rest}
                    >
                        {children}
                    </RadioButtonCard>
                ),
            )}
            <ErrorMessageLabel errorMessage={errorMessage} errorId={errorId} />
        </fieldset>
    );
};

export default RadioButtonCards;
